import { sleep } from "@shared/sleep";

export default async function pkalert(header: string, message: string, $dom?: JQuery): Promise<void>;
export default async function pkalert(message: string, $dom?: JQuery): Promise<void>;
export default async function pkalert(...args: any[]) {
  let i = 0;
  let header: string;
  let message: string;
  let $dom: JQuery;
  if (typeof (args[0]) === 'string' && typeof (args[1]) === 'string') header = args[i++];
  if (typeof (args[i]) === 'string') message = args[i++];
  $dom = args[i++];

  let $overlay = $(
    '<div class="overlay alert">' +
    '<div class="bg"></div>' +
    '<div class="table"><div class="cell">' +
    '<div class="alertContent">' +
    (header ? '<div class="alertHeader">' + header + '</div>' : '') +
    '<div class="message">' + message + '</div>' +
    '</div>' +
    '</div></div>' +
    '</div>'
  ).hide();
  $('body').append($overlay);

  if ($dom) {
    $overlay.addClass('context');
    $overlay.css({
      position: 'absolute',
      top: $dom.offset().top - $overlay.height(),
      left: $dom.offset().left,
      width: $dom.outerWidth() + (parseInt($dom.css('paddingLeft'), 10) || 0) + (parseInt($dom.css('paddingRight'), 10) || 0),
      margin: 0
    });
  } else {
    $overlay.addClass('global');
  }

  $overlay.fadeIn(200);
  await sleep(0);
  $(document).one('click', function click(e) {
    if ($(e.target).parents().add(e.target).filter('.alertContent').length > 0) {
      return $(document).one('click', click);
    }
    $overlay.stop().fadeOut(150, function () {
      $(this).remove();
    });
  });
}